import { Component, DoCheck } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxPaginationModule } from 'ngx-pagination';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { CommonService } from '../_service/common.service';
import { appConfig } from '../app.config';
import { PagerService } from '../_service/pager-service';
import { SupplierService } from '../_service/supplier.service';
import { SitesService } from '../_service/sites.service';
import { AddressService } from '../_service/address.service';

const TEN = 10;
const TWENTY = 20;
const THREE_HUNDRED = 300;
const STEP_DELAY_MS = 3000;

@Component({
    selector: 'app-orbis',
    templateUrl: './orbis.component.html',
    styleUrls: ['./orbis.component.css'],
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatProgressSpinnerModule, NgxPaginationModule,
        HelpsectionComponent, SuppliertabComponent
    ]
})
export class OrbisComponent implements DoCheck {

  Config = appConfig
  public envHide: boolean;
  public customLoadingTemplate: boolean;
  public customLoadingTemplate2: boolean;
  public roleVariableHide = false;
  public prodHide = false;
  public superUserShow = false;
  public showBuyerProfile = false;
  public showForConsult = false;
  showForSupplier: boolean;
  roleIsManager = false;
  public checkGuoStartDate = '';
  showResultsCheckGUO = false;
  public bvdIddata = [];
  loadData = false;
  PageTotalLength: number;
  disableCheckGuo = false;
  showResultsPortfolio = false;
  portfolioList = [];
  portfolio = [];
  loadPortfolioData = false;
  fileToUpload: File = null;
  arrayOfBVDIDsToImportOrRemove = [];
  bvdIDsObject = [];
  inPortfolioLoading = false;
  uploadDocError = false;
  selectFileError = false;
  disableUploadBtn = false;
  importIsOn = false;
  pager: any = {};
  tempPortfolioList = [];
  tempBvdIddata = [];
  orbisBvdData = [];
  orbisBvdDataLoading = true;
  dataloading = false;
  siteIdTemp = '';
  rowID: any;
  IsaData = [];
  portfolioData = [];
  orbisIdData = [];
  rowIDs = [];
  isaName = [];
  pagename: string;
  message: boolean;
  activityA = [];
  activityLoaded: boolean;
  optActivityA: { value: string, checked: boolean }[];
  Avalue = [];
  AvalueSelected = [];
  companyIds = [];
  bvdIds = [];
  selectedValue = '';
  selectedBvd = [];
  tempSelectedBvd = [];
  errorMsg = '';
  uploadDocError1: boolean;
  testing = ''
  key = 'name';
  reverse = false;
  portPager: any = {};
  twenty = TWENTY
  constructor(public readonly commonService: CommonService, readonly router: Router, readonly pagerService: PagerService, readonly supplierService: SupplierService, readonly sitesService: SitesService, readonly addressService: AddressService) {
    this.Config = appConfig;
  }

  ngDoCheck() {
    this.getRoles();
  }

  getRoles() {
    const RoleByService = this.commonService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  checkAllProfilesAndEnv(RoleByService) {
    const c = RoleByService;
    if (c['buyer'] === 'yes') {
      this.showBuyerProfile = false;
    } else {
      this.showBuyerProfile = true;
    }
    if (c['env'] === 'qua' || c['env'] === 're7' || c['env'] === 'ope') {
      this.envHide = false;
    } else {
      this.envHide = true;
    }
    if (c['role'] === 'admin' || c['role'].includes('admin')) {
      this.roleVariableHide = true;
    } else {
      this.roleVariableHide = false;
    }
    if (c['role'] === 'manager') {
      this.roleIsManager = true;
    } else {
      this.roleIsManager = false;
    }
    if (c['superAdmin'] === 'yes') {
      this.superUserShow = true;
    } else {
      this.superUserShow = false;
      if (this.roleVariableHide == false) {
        console.info("Not authorized");
        this.router.navigateByUrl('/sites');
      }
    }
    if (c['env'] === 'ope') {
      this.prodHide = true;
    } else {
      this.prodHide = false;
    }


    if (c['role'] === 'consult' || c['role'].includes('consult')) {
      this.showForConsult = false;
    } else {
      this.showForConsult = true;
    }
    if (c['role'] === 'supplier') {
      this.showForSupplier = false;
    } else {
      this.showForSupplier = true;
    }
  }

  openCheckguoModal() {
    this.checkGuoStartDate = '';
    this.showResultsCheckGUO = false;
    this.disableCheckGuo = false;
    this.showResultsPortfolio = false;
    this.bvdIddata = [];
    this.tempBvdIddata = [];
  }

  getSupplierActivity() {
    this.AvalueSelected = []
    this.Avalue = []
    this.activityA = [];
    this.optActivityA = []
    this.activityLoaded = false;
    let types = []
    let optA = [];
    this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types?name=SUPPLIER%20ACTIVITY`).subscribe((data: any) => {
      data['company-name-types'].forEach(data1 => {
        data1.description = data1.description.replace('<p>', '')
        data1.description = data1.description.replace('</p>', '')
        types = data1.description.split(/<br\s*\/?>/i)
      })
      types.forEach(datas => {
        if (datas.includes("A#")) {
          datas = datas.replace("A#", '')
          optA.push(datas)
        }
      })
    })

    setTimeout(() => {
      optA.forEach(data => {
        this.optActivityA.push({ value: data, checked: false })
        this.Avalue.push(`A#${data}`)
      })
      this.activityLoaded = true;
    }, STEP_DELAY_MS)
  }

  checkGuo(max = THREE_HUNDRED, offset = 0, page = 1) {
    let endDate;
    let startDate;
    this.disableCheckGuo = true;
    this.showResultsPortfolio = false;
    if (this.checkGuoStartDate === '1 week') {
      endDate = this.commonService.getTodayDate();
      startDate = this.commonService.getOneWeekAgoDate();
    } else if (this.checkGuoStartDate === '2 week') {
      endDate = this.commonService.getTodayDate();
      startDate = this.commonService.getTwoWeekAgoDate();
    } else if (this.checkGuoStartDate === '1 month') {
      endDate = this.commonService.getTodayDate();
      startDate = this.commonService.getOneMonthAgoDate();
    } else if (this.checkGuoStartDate === '3 month') {
      endDate = this.commonService.getTodayDate();
      startDate = this.commonService.getThreeMonthAgoDate();
    }
    const bvdCheckGuo = `${this.Config.bvdOrbisUrl}data?QUERY={"WHERE":{"AND":[{"RecordSet": "${this.commonService.PortfolioRecordSet}"},{"UpdatedOwnership": {"Period": {"Start":"${startDate}","End":"${endDate}"},"ShareHolders":["UOUpdated"]}}]},"SELECT": ["BVDID", "NAME", "COUNTRY", "CITY", "GUO_BVD_ID_NUMBER", "GUO_NAME"], "ORDERBY":{"ASC":"BVDID"}, "RANGE":{"MAX":${max}, "OFFSET":${offset}}}`;
    this.commonService.getCustomURLOrbis(bvdCheckGuo).subscribe(bvdData => {
      if (bvdData['Data'].length > 0) {
        bvdData['Data'].forEach(element => {
          if (element.BVDID !== 'null' && element.BVDID !== null && element.BVDID !== 'undefined' && element.BVDID !== '') {
            this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${element.BVDID}`).subscribe((data1) => {
              if (data1['business-entity-identifiers'].length > 0) {
                element.GUOinISA = data1['business-entity-identifiers'][0].value;
                if (element.GUOinISA == element.GUO_BVD_ID_NUMBER) {
                  element.GUOinISACheck = true;
                } else {
                  element.GUOinISACheck = false;
                }
                const businessEntId = data1['business-entity-identifiers'][0]['businessEntityId'];
                this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities/${businessEntId}`).subscribe((data2) => {
                  if (data2) {
                    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&companyId=${data2['companyId']}`).subscribe((data3) => {
                      if (data3['group-assignments'].length > 0) {
                        element.GUOinISAName = data3['group-assignments'][0]['groupName'];
                      }
                    }, error => {
                      console.info(error);
                    });
                  }
                }, error => {
                  console.info(error);
                });
              } else {
                element.GUOinISACheck = false;
              }
            }, error => {
              console.info(error);
            });
          }
          this.bvdIddata.push(element);
        });
        this.loadData = true;
        this.PageTotalLength = bvdData['SearchSummary']['TotalRecordsFound'];
      } else {
        this.loadData = false;
        this.PageTotalLength = bvdData['SearchSummary']['TotalRecordsFound'];
      }
      if (bvdData['SearchSummary']['TotalRecordsFound'] > bvdData['SearchSummary']['RecordsReturned']) {
        if (this.bvdIddata.length !== bvdData['SearchSummary']['TotalRecordsFound']) {
          this.checkGuo(max, offset + bvdData['SearchSummary']['RecordsReturned']);
        } else {
          document.getElementById('closeCheckguo').click();
          this.showResultsCheckGUO = true;
          this.pager = this.pagerService.getPager(this.PageTotalLength, page, this.twenty);
          this.tempBvdIddata = this.bvdIddata;
          this.bvdIddata = this.bvdIddata.slice(this.pager.startIndex, this.pager.endIndex + 1);
        }
      } else {
        document.getElementById('closeCheckguo').click();
        this.showResultsCheckGUO = true;
        this.pager = this.pagerService.getPager(this.PageTotalLength, page, this.twenty);
        this.tempBvdIddata = this.bvdIddata;
        this.bvdIddata = this.bvdIddata.slice(this.pager.startIndex, this.pager.endIndex + 1);
      }
    }, error => {
      console.info(error);
    });
  }

  getPagerForCheckGuo(page = 1) {
    this.pager = this.pagerService.getPager(this.tempSelectedBvd.length, page, this.twenty);
    this.selectedBvd = this.tempSelectedBvd.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.LoadGuo()
  }
  goToPage(page: number) {
    if (page >= 1 && page <= this.pager.totalPages) {
      this.getPagerForCheckGuo(page);
    }
  }

  nextPage() {
    if (this.pager.currentPage < this.pager.totalPages) {
      this.goToPage(this.pager.currentPage + 1);
    }
  }

  previousPage() {
    if (this.pager.currentPage > 1) {
      this.goToPage(this.pager.currentPage - 1);
    }
  }
  openPortfolioList(name = '', page = 1) {
    this.showResultsPortfolio = true;
    this.showResultsCheckGUO = false;
    this.inPortfolioLoading = true;
    this.tempPortfolioList = [];
    this.pagename = name
    const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${this.commonService.PortfolioRecordSet}`;
    this.commonService.getCustomURLOrbis(bvdOrbisUrl).subscribe(bvdData => {
      if (bvdData['BvDIDs'].length > 0) {
        this.portfolioList = bvdData['BvDIDs'];
        this.loadPortfolioData = true;
        this.inPortfolioLoading = false;
      } else {
        this.loadPortfolioData = false;
        this.inPortfolioLoading = false;
      }
      this.PageTotalLength = bvdData['BvDIDs'].length;
      this.portPager = this.pagerService.getPager(this.PageTotalLength, page, this.twenty);
      this.tempPortfolioList = this.portfolioList;
      this.portfolioList = this.portfolioList.slice(this.portPager.startIndex, this.portPager.endIndex + 1);
      if (name === 'orbis') {
        document.getElementById('closeEditActivity').click();
        this.orbisIdData = []
        this.GetCompanySelected()
      }
    }, error => {
      console.info("error", error)
      this.loadPortfolioData = false;
    });
  }
  GetCompanySelected(index = 0, subscribeData = [], page = 1) {
    this.showResultsPortfolio = false;
    this.orbisBvdDataLoading = true;
    this.dataloading = true;
    this.showResultsCheckGUO = true;
    this.loadData = true;
    this.message = false
    this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SUPPLIER%20ACTIVITY&value=*${this.AvalueSelected[index]}&_page=${page}`).subscribe((data: any) => {
      data['company-names'].forEach(data => {
        subscribeData.push(data)
        if (this.companyIds.findIndex(x => x == data['companyId']) == -1) {
          this.companyIds.push(data['companyId'])
        }
      })
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.GetCompanySelected(index, subscribeData, page + 1)
      } else if (data['maxPage'] == page) {
        if (index != this.AvalueSelected.length - 1) {
          this.GetCompanySelected(index + 1, subscribeData, page)
        } else {
          if (this.companyIds.length > 0) {
            this.getCpyBusinessEntities(this.companyIds)
          }
          else {
            this.orbisBvdDataLoading = false
          }
        }
      }
    })

    console.info('companyId', this.companyIds)

  }

  getCpyBusinessEntities(cpyIds, page = 1, subscribeData = [], businessEntityIds = [], splitrowids = [], morethan20rec = false, remainingRows = [], pageChanged = 'yes') {
    if (cpyIds.length > 0) {
      if (pageChanged === 'yes') {
        if (cpyIds.length > this.twenty) {
          splitrowids = cpyIds.slice(0, this.twenty);
          remainingRows = cpyIds.slice(this.twenty, cpyIds.length);
          morethan20rec = true;
        } else {
          splitrowids = cpyIds;
          morethan20rec = false;
        }
      }
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['business-entities'].length > 0) {
          data['business-entities'].forEach(e => {
            if (subscribeData[e.row_id] === undefined) {
              subscribeData[e.row_id] = [];
            }
            subscribeData[e.row_id] = e;
            if (businessEntityIds.indexOf(e.row_id) === -1) {
              businessEntityIds.push(e.row_id);
            }
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] !== page) {
          this.getCpyBusinessEntities(cpyIds, page + 1, subscribeData, businessEntityIds, splitrowids, morethan20rec, remainingRows, 'no');
        } else if (data['maxPage'] === page) {
          if (morethan20rec === true) {
            this.getCpyBusinessEntities(remainingRows, 1, subscribeData, businessEntityIds, splitrowids, morethan20rec, remainingRows, 'yes');
          } else {
            console.info('businessEntityIds', businessEntityIds)
            this.bvdIds = []
            this.getBvDIdsForCpy(businessEntityIds, subscribeData);
          }
        }
      });
    }
  }

  getBvDIdsForCpy(beIds, subscribeData1, page = 1, subscribeData: any = [], bvdIds = [], hasCpyBvd = false, splitrowids = [], morethan20rec = false, remainingRows = [], pageChanged = 'yes') {
    if (beIds.length > 0) {
      if (pageChanged === 'yes') {
        if (beIds.length > this.twenty) {
          splitrowids = beIds.slice(0, this.twenty);
          remainingRows = beIds.slice(this.twenty, beIds.length);
          morethan20rec = true;
        } else {
          splitrowids = beIds;
          morethan20rec = false;
        }
      }
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${splitrowids})&businessEntityIdentifierTypeName=BVD%20ID&_page=${page}`).subscribe(data => {
        if (data['business-entity-identifiers'].length > 0) {
          data['business-entity-identifiers'].forEach(e => {
            if (subscribeData[e.value] === undefined) {
              subscribeData[e.value] = [];
            }
            subscribeData[e.value] = e;
            if (bvdIds.indexOf(e.value) === -1) {
              bvdIds.push(e.value);
            }
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] !== page) {
          this.getBvDIdsForCpy(beIds, subscribeData1, page + 1, subscribeData, bvdIds, hasCpyBvd, splitrowids, morethan20rec, remainingRows, 'no');
        } else if (data['maxPage'] === page) {
          if (morethan20rec === true) {
            this.getBvDIdsForCpy(remainingRows, subscribeData1, 1, subscribeData, bvdIds, hasCpyBvd, splitrowids, morethan20rec, remainingRows, 'yes');
          } else {
            console.info('bvdIds', bvdIds)
            if (bvdIds.length > 0) {
              this.bvdIds = bvdIds;
              this.selectedBvd = this.bvdIds;
              this.tempSelectedBvd = this.selectedBvd
              this.PageTotalLength = this.bvdIds.length;
              this.pager = this.pagerService.getPager(this.PageTotalLength, page, this.twenty);
              this.selectedBvd = this.selectedBvd.slice(this.pager.startIndex, this.pager.endIndex + 1);
              this.LoadGuo();

            }
          }
        }
      });
    }
  }
  getSelectedValue(value) {

    if (this.AvalueSelected.findIndex(x => x == value.value) == -1) {
      this.AvalueSelected.push(value.value)

    }
    console.info('chjecked', this.AvalueSelected)
  }
  getPager(page = 1) {
    this.portPager = this.pagerService.getPager(this.tempPortfolioList.length, page, this.twenty);
    this.portfolioList = this.tempPortfolioList.slice(this.portPager.startIndex, this.portPager.endIndex + 1);
  }
  loadTheValues(operationToDo) {
    const inputFile = document.getElementById("file") as HTMLInputElement;
    inputFile.value = "";
    this.bvdIDsObject = [];
    this.arrayOfBVDIDsToImportOrRemove = [];
    this.uploadDocError = false;
    this.selectFileError = false;
    this.disableUploadBtn = false;
    this.uploadDocError1 = false;
    if (operationToDo == 'add') {
      this.importIsOn = true;
    } else {
      this.importIsOn = false;
    }
  }

  changeListener($event) {
    this.selectFileError = false;
    this.uploadDocError = false;
    this.uploadDocError1 = false;
    this.readThis($event.target);
  }

  readThis(inputValue) {
    this.fileToUpload = inputValue.files[0];
    const allowedFileTypes = ['txt'];
    const splits = this.fileToUpload.name.split('.');
    const maxSplitLen = splits.length;
    const extension = splits[maxSplitLen - 1].toLowerCase();
    if (!allowedFileTypes.includes(extension)) {
      this.uploadDocError1 = true;
    } else {
      this.uploadDocError1 = false;
    }
  }

  importClickFunction(operationToDo) {
    if (this.fileToUpload !== null && this.uploadDocError1 === false) {
      this.selectFileError = false;
      this.disableUploadBtn = true;
      const reader: FileReader = new FileReader();
      reader.readAsText(this.fileToUpload);
      reader.onload = (_e) => {
        const txt: any = reader.result;
        this.arrayOfBVDIDsToImportOrRemove = txt.split(/\r\n/);
        this.importRemoveBVDIDsToList(this.arrayOfBVDIDsToImportOrRemove, operationToDo);
      }
    } else {
      if (this.uploadDocError1 == false) {
        this.selectFileError = true;
      }
    }
  }

  importRemoveBVDIDsToList(bvdIDs, operationToDo, splitbvdids = [], morethan10rec = false, remainingRows = []) {
    this.bvdIDsObject = [];
    if (bvdIDs.length > 0) {
      if (bvdIDs.length > TEN) {
        splitbvdids = bvdIDs.slice(0, TEN);
        remainingRows = bvdIDs.slice(TEN, bvdIDs.length);
        morethan10rec = true;
      } else {
        morethan10rec = false;
        splitbvdids = bvdIDs;
      }
      const urlOperation = operationToDo;
      const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.commonService.PortfolioRecordSet}`;
      const datas =
      {
        'WHERE':
          [
            {
              "BvDID": splitbvdids
            }
          ]
      }
      console.info("datas", datas)
      this.commonService.putCustomURLOrbis(bvdOrbisUrl, datas).subscribe(() => {
        if (morethan10rec === true) {
          this.importRemoveBVDIDsToList(remainingRows, operationToDo, splitbvdids, morethan10rec, remainingRows);
        } else {
          document.getElementById('closeAddOrRemoveBvdModal').click();
          this.disableUploadBtn = false;
          this.openPortfolioList();
        }
      }, _error => {
        this.uploadDocError = true;
        this.disableUploadBtn = false;
      });
    }
  }

  ExportportfolioToExcel() {
    this.portfolio = [];
    const bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${this.commonService.PortfolioRecordSet}`;
    this.commonService.getCustomURLOrbis(bvdOrbisUrl).subscribe(bvdData => {
      for (let i = 0; i < bvdData['BvDIDs'].length; i++) {
        this.portfolio.push(`${bvdData['BvDIDs'][i]}\n`);
      }
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(this.portfolio, { type: 'text/plain;charset=utf-8' }));
      downloadLink.setAttribute('download', 'BVDIDexported' + '.txt');
      document.body.appendChild(downloadLink);
      downloadLink.click();;
    });
  }
  LoadGuo(i = 0) {
    this.showResultsPortfolio = false;
    this.orbisBvdDataLoading = true;
    this.dataloading = true;
    this.showResultsCheckGUO = true;
    this.loadData = true;
    this.message = false;
    const datas = {}
    let oldBvdId = []
    let grpAllianceIdForGR = ''
    if (i === 0) {
      this.bvdIddata = [];
      this.orbisIdData = [];
      this.IsaData = [];
      this.isaName = [];
      oldBvdId = []
    }
    if (this.selectedBvd.length === 0) {
      this.message = true
    }
    else {
      const bvd1 = this.selectedBvd[i]
      this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface?bvd-id=${bvd1}`, datas).subscribe((data) => {
        this.orbisBvdData = [];
        if (data !== null) {
          let tempData = JSON.parse(data.result);
          this.orbisBvdData = tempData['Data'][0];
          this.bvdIddata[bvd1] = this.orbisBvdData
        }
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${bvd1}`).subscribe(ids => {
          if (ids && ids['business-entity-identifiers'] && ids['business-entity-identifiers'].length > 0 &&
            ids['business-entity-identifiers'][0] && ids['business-entity-identifiers'][0]['businessEntityAllianceIdentifier']) {

            this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?identifier=${ids['business-entity-identifiers'][0]['businessEntityAllianceIdentifier']}`).subscribe(datas => {
              if (datas['business-entities'].length > 0) {
                this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&status=VALIDATED&companyId=${datas['business-entities'][0]['companyId']}`).subscribe(dataq => {
                  if (dataq['group-assignments'].length > 0) {
                    this.isaName[bvd1] = {
                      'grpname': dataq['group-assignments'][0]['groupName']
                    }
                    grpAllianceIdForGR = dataq['group-assignments'][0]['groupAllianceIdentifier']
                    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups?allianceIdentifier=${grpAllianceIdForGR}&_page=1&_pagesize=10`).subscribe((data2: any) => {
                      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${data2['groups'][0]['representingCompanyId']}&isHQ=Y`).subscribe(data0 => {
                        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityAllianceIdentifier=${data0['business-entities'][0]['identifier']}`).subscribe(ids => {
                          if (ids && ids['business-entity-identifiers'] && ids['business-entity-identifiers'].length > 0 &&
                            ids['business-entity-identifiers'][0] && ids['business-entity-identifiers'][0]["value"]) {

                            this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface?bvd-id=${ids['business-entity-identifiers'][0]["value"]}`, datas).subscribe((data: any) => {
                              if (data['bvd-id'] !== bvd1) {
                                let tempData = JSON.parse(data.result);
                                this.bvdIddata[bvd1] = tempData['Data'][0]
                                oldBvdId[bvd1] = { 'oldBvdId': bvd1 }
                                this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=${ids['business-entity-identifiers'][0]["businessEntityId"]}`).subscribe(details => {
                                  if (details['site-assignments'].length !== 0) {
                                    details['site-assignments'].forEach(elements => {
                                      this.siteIdTemp = elements.site.href.split('/')
                                    })
                                    this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=${this.siteIdTemp[1]}`).subscribe((ent: any) => {
                                      this.rowID = ''
                                      ent['access-points'].forEach(element => {
                                        if (element.type === 'P14' && element.activeStatus === 'ACTIVE') {
                                          this.rowID = element.rowId
                                        }
                                      })
                                      if (this.rowID !== '') {
                                        this.sitesService.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=${this.rowID}&addressType=GEOGRAPHICAL`).subscribe(address => {
                                          this.addressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=${address["access-points-addresses"][0]["addressId"]}`).subscribe(geo => {
                                            geo['geographical-addresses'].forEach(address2 => {
                                              this.IsaData[bvd1] = address2
                                            })
                                            if (this.bvdIddata.hasOwnProperty(bvd1)) {
                                              if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                                this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1], ...oldBvdId[bvd1] }
                                                this.orbisIdData.push(this.bvdIddata[bvd1])
                                              }
                                              if (i < this.selectedBvd.length - 1) {
                                                this.LoadGuo(i + 1)
                                              } else {
                                                this.orbisBvdDataLoading = false;
                                                this.dataloading = false
                                              }
                                            } else {
                                              if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                                this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1], ...oldBvdId[bvd1] }
                                                this.orbisIdData.push(this.bvdIddata[bvd1])
                                              }
                                              if (i < this.selectedBvd.length - 1) {
                                                this.LoadGuo(i + 1)
                                              } else {
                                                this.orbisBvdDataLoading = false;
                                                this.dataloading = false
                                              }
                                            }
                                          })
                                        })
                                      }
                                      else {
                                        this.IsaData[bvd1] = ''
                                        if (this.bvdIddata.hasOwnProperty(bvd1)) {
                                          this.orbisBvdDataLoading = false;
                                          this.dataloading = false
                                          if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                            this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1], ...oldBvdId[bvd1] }
                                            this.orbisIdData.push(this.bvdIddata[bvd1])
                                            if (i < this.PageTotalLength - 1) {
                                              this.LoadGuo(i + 1)
                                            }
                                          } else {
                                            if (i < this.PageTotalLength - 1) {
                                              this.LoadGuo(i + 1)
                                            }
                                          }
                                        } else {
                                          if (i < this.PageTotalLength - 1) {
                                            this.LoadGuo(i + 1)
                                          }
                                        }
                                      }
                                    })
                                  }
                                  else if (details['site-assignments'].length === 0) {
                                    this.IsaData[bvd1] = ''
                                    oldBvdId[bvd1] = { 'oldBvdId': '' }
                                    if (this.bvdIddata.hasOwnProperty(bvd1)) {
                                      this.orbisBvdDataLoading = false;
                                      this.dataloading = false
                                      if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                        this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1], ...oldBvdId[bvd1] }
                                        this.orbisIdData.push(this.bvdIddata[bvd1])
                                        if (i < this.PageTotalLength - 1) {
                                          this.LoadGuo(i + 1)
                                        }
                                      } else {
                                        if (i < this.PageTotalLength - 1) {
                                          this.LoadGuo(i + 1)
                                        }
                                      }
                                    } else {
                                      if (i < this.PageTotalLength - 1) {
                                        this.LoadGuo(i + 1)
                                      }
                                    }

                                  }
                                })
                              }
                              else {
                                this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=${ids['business-entity-identifiers'][0]["businessEntityId"]}`).subscribe(details => {
                                  if (details['site-assignments'].length !== 0) {
                                    details['site-assignments'].forEach(elements => {
                                      this.siteIdTemp = elements.site.href.split('/')
                                    })
                                    this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=${this.siteIdTemp[1]}`).subscribe((ent: any) => {
                                      this.rowID = ''
                                      ent['access-points'].forEach(element => {
                                        if (element.type === 'P14' && element.activeStatus === 'ACTIVE') {
                                          this.rowID = element.rowId
                                        }
                                      })
                                      if (this.rowID !== '') {
                                        this.sitesService.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=${this.rowID}&addressType=GEOGRAPHICAL`).subscribe(address => {
                                          this.addressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=${address["access-points-addresses"][0]["addressId"]}`).subscribe(geo => {
                                            geo['geographical-addresses'].forEach(address2 => {
                                              this.IsaData[bvd1] = address2
                                            })
                                            if (this.bvdIddata.hasOwnProperty(bvd1)) {
                                              this.orbisBvdDataLoading = false;
                                              this.dataloading = false
                                              if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                                this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1] }
                                                this.orbisIdData.push(this.bvdIddata[bvd1])
                                                if (i < this.PageTotalLength - 1) {
                                                  this.LoadGuo(i + 1)
                                                }
                                              } else {
                                                this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1] }
                                                this.orbisIdData.push(this.bvdIddata[bvd1])
                                                if (i < this.PageTotalLength - 1) {
                                                  this.LoadGuo(i + 1)
                                                }
                                              }
                                            } else {
                                              if (i < this.PageTotalLength - 1) {
                                                this.LoadGuo(i + 1)
                                              }
                                            }
                                          })
                                        })
                                      }
                                      else {
                                        this.IsaData[bvd1] = ''
                                        oldBvdId[bvd1] = { 'oldBvdId': '' }
                                        if (this.bvdIddata.hasOwnProperty(bvd1)) {
                                          this.orbisBvdDataLoading = false;
                                          this.dataloading = false
                                          if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                            this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1], ...oldBvdId[bvd1] }
                                            this.orbisIdData.push(this.bvdIddata[bvd1])
                                            if (i < this.PageTotalLength - 1) {
                                              this.LoadGuo(i + 1)
                                            }
                                          } else {
                                            this.orbisBvdDataLoading = false;
                                            this.dataloading = false
                                            this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1], ...oldBvdId[bvd1] }
                                            this.orbisIdData.push(this.bvdIddata[bvd1])
                                            if (i < this.PageTotalLength - 1) {
                                              this.LoadGuo(i + 1)
                                            }
                                          }
                                        } else {
                                          if (i < this.PageTotalLength - 1) {
                                            this.LoadGuo(i + 1)
                                          }
                                        }
                                      }
                                    })
                                  }
                                  else if (details['site-assignments'].length === 0) {
                                    this.IsaData[bvd1] = ''
                                    oldBvdId[bvd1] = { 'oldBvdId': '' }
                                    if (this.bvdIddata.hasOwnProperty(bvd1)) {
                                      this.orbisBvdDataLoading = false;
                                      this.dataloading = false
                                      if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                        this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1], ...oldBvdId[bvd1] }
                                        this.orbisIdData.push(this.bvdIddata[bvd1])
                                        if (i < this.PageTotalLength - 1) {
                                          this.LoadGuo(i + 1)
                                        }
                                      } else {
                                        if (i < this.PageTotalLength - 1) {
                                          this.LoadGuo(i + 1)
                                        }
                                      }
                                    } else {
                                      if (i < this.PageTotalLength - 1) {
                                        this.LoadGuo(i + 1)
                                      }
                                    }
                                  }
                                })
                              }
                            }, () => {
                              if (i < this.PageTotalLength - 1) {
                                this.LoadGuo(i + 1)
                              }
                            })
                          } else {
                            if (i < this.PageTotalLength - 1) {
                              this.LoadGuo(i + 1)
                            }
                          }

                        })
                      })
                    })
                  }
                  else {
                    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=${ids["business-entity-identifiers"][0]["businessEntityId"]}`).subscribe(details => {
                      if (details['site-assignments'].length !== 0) {
                        details['site-assignments'].forEach(elements => {
                          this.siteIdTemp = elements.site.href.split('/')
                        })
                        this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=${this.siteIdTemp[1]}`).subscribe((ent: any) => {
                          this.rowID = ''
                          ent['access-points'].forEach(element => {
                            if (element.type === 'P14' && element.activeStatus === 'ACTIVE') {
                              this.rowID = element.rowId
                            }
                          })
                          if (this.rowID !== '') {
                            this.sitesService.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=${this.rowID}&addressType=GEOGRAPHICAL`).subscribe(address => {
                              this.addressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=${address["access-points-addresses"][0]["addressId"]}`).subscribe(geo => {
                                geo['geographical-addresses'].forEach(address2 => {
                                  this.IsaData[bvd1] = address2
                                })
                                if (this.bvdIddata.hasOwnProperty(bvd1)) {
                                  this.orbisBvdDataLoading = false;
                                  this.dataloading = false
                                  if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                    this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1] }
                                    this.orbisIdData.push(this.bvdIddata[bvd1])
                                    if (i < this.PageTotalLength - 1) {
                                      this.LoadGuo(i + 1)
                                    }
                                  } else {
                                    if (i < this.PageTotalLength - 1) {
                                      this.LoadGuo(i + 1)
                                    }
                                  }
                                } else {
                                  if (i < this.PageTotalLength - 1) {
                                    this.LoadGuo(i + 1)
                                  }
                                }
                              })
                            })
                          }
                          else {
                            this.IsaData[bvd1] = ''
                            if (this.bvdIddata.hasOwnProperty(bvd1)) {
                              this.orbisBvdDataLoading = false;
                              this.dataloading = false
                              if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                                this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1] }
                                this.orbisIdData.push(this.bvdIddata[bvd1])
                                if (i < this.PageTotalLength - 1) {
                                  this.LoadGuo(i + 1)
                                }
                              } else {
                                this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1] }
                                this.orbisIdData.push(this.bvdIddata[bvd1])
                                if (i < this.PageTotalLength - 1) {
                                  this.LoadGuo(i + 1)
                                }
                              }
                            } else {
                              if (i < this.PageTotalLength - 1) {
                                this.LoadGuo(i + 1)
                              }
                            }
                          }
                        })
                      }
                      else if (details['site-assignments'].length === 0) {
                        this.IsaData[bvd1] = ''
                        if (this.bvdIddata.hasOwnProperty(bvd1)) {
                          if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                            this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1] }
                            this.orbisIdData.push(this.bvdIddata[bvd1])
                          }
                          if (i < this.selectedBvd.length - 1) {
                            this.LoadGuo(i + 1)
                          } else {
                            this.orbisBvdDataLoading = false;
                            this.dataloading = false
                          }
                        } else {
                          if (i < this.selectedBvd.length - 1) {
                            this.LoadGuo(i + 1)
                          } else {
                            this.orbisBvdDataLoading = false;
                            this.dataloading = false
                          }
                        }

                      }
                    })
                  }
                })
              }
              else {
                this.IsaData[bvd1] = ''
                oldBvdId[bvd1] = { 'oldBvdId': '' }
                if (this.bvdIddata.hasOwnProperty(bvd1)) {
                  this.orbisBvdDataLoading = false;
                  this.dataloading = false
                  if (this.orbisIdData.findIndex(x => x.BVD_ID_NUMBER === bvd1) === -1) {
                    this.bvdIddata[bvd1] = { ...this.bvdIddata[bvd1], ...this.IsaData[bvd1], ...this.isaName[bvd1], ...oldBvdId[bvd1] }
                    this.orbisIdData.push(this.bvdIddata[bvd1])
                    if (i < this.PageTotalLength - 1) {
                      this.LoadGuo(i + 1)
                    }
                  } else {
                    if (i < this.PageTotalLength - 1) {
                      this.LoadGuo(i + 1)
                    }
                  }
                } else {
                  if (i < this.PageTotalLength - 1) {
                    this.LoadGuo(i + 1)
                  }
                }
              }
            })
          } else {
            if (i < this.selectedBvd.length - 1) {
              this.LoadGuo(i + 1)
            } else {
              this.orbisBvdDataLoading = false;
              this.dataloading = false
            }
          }
        })
      }, _err => {
        if (i < this.selectedBvd.length - 1) {
          this.LoadGuo(i + 1)
        } else {
          this.orbisBvdDataLoading = false;
          this.dataloading = false
        }
      })

      this.loadData = true;
    }
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

}